
// 导航栏
import { showPageBack, routerHasChange } from '@constrant/Enum.js';

export default {

  methods: {
    initListener() {
      service.Hookable.remove(showPageBack, this.showPageBack);
      service.Hookable.remove(routerHasChange, this.updatePageBackState);

      service.Hookable.hook(showPageBack, this.showPageBack);
      service.Hookable.hook(routerHasChange, this.updatePageBackState);
    },

    updatePageBackState() {
      this.$refs.pageBack.update(window.routerStack);
    },

    showPageBack(options) {
      this.$refs.pageBack.show(options);
    },
  },

  created() {
    this.initListener();
  },
};

